module.exports = __webpack_public_path__ + "img/ceshi3.a2216a29.png";